import {fractionToPercent} from "../../../performance/PercentageChange";
import React from "react";

export const StopLoss = ({idea}) => {
    const value = idea.stopLoss ? fractionToPercent(idea.stopLoss) + "%" : "\u2014";
    return <div className="t-stop-loss">{value}</div>;
};